import Select from '@/common/components/Inputs/Select/Select';

export default Select;
